import { UseQueryResult, useQuery } from 'react-query'

import { QueryKey } from '@/configs/queryKeys'
import { IListarVendaResultado } from '@/interfaces/pedidos'
import { getListarItensVendas } from '@/services/pedidos'

export function useGetListarVendas({
  params
}: {
  params: {
    pedidoId: string
    operadoraId?: string
    inicio: number
    comprimento: number
    procurar?: string
    situacoesItem?: string[]
    tipoVenda?: string
    agrupar?: boolean
  }
}): UseQueryResult<IListarVendaResultado> {
  return useQuery([QueryKey.listarVendasV2, { params }], getListarItensVendas, {
    enabled: !!params.pedidoId,
    retry: true,
    keepPreviousData: false,
    cacheTime: 0
  })
}
